import styled from "styled-components";
import stylesChart from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";

// Styled Components

const TitleWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const TitleStyled = styled.h4`
  margin-top: 28px;
  color: #3c4858;
  z-index: 0;
`;

// Styles Mui
const styles = () => ({
  ...stylesChart,
  cardBody: {
    position: "relative",
  },
  cardHeader: {
    zIndex: "0 !important",
  },
  buttonIcon: {
    margin: "0 !Important",
  },
});

export { styles, TitleStyled, TitleWrapperStyled };
